import { FC, useCallback } from 'react';
import { useHistory } from 'react-router';
import { Capacitor } from '@capacitor/core';
import { CardBanner } from 'components/Home';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { ROUTER_URL } from 'utils/enums';
import { FirebaseAnalytics } from 'utils/services';

export const CardBannerPage: FC = () => {
	const history = useHistory();
	const platform = Capacitor.getPlatform();
	const isWeb = platform === 'web';

	const handleClickCardBanner = useCallback(() => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.CREATE_CARD_BANNER,
			FIREBASE_EVENT_ANALYTICS_BUTTON.CREATE_CARD_RADABANK
		);

		history.push({
			pathname: ROUTER_URL.RADABANK_CARD_AUTH_INFO_BEGIN,
			state: { isFromCard: true },
		});
	}, [history]);

	const handleClickSkip = useCallback(async () => {
		FirebaseAnalytics.logEvent(FIREBASE_EVENT_ANALYTICS_PAGE.AUTH.UPDATE_PROFILE, FIREBASE_EVENT_ANALYTICS_BUTTON.SKIP);

		const redirectTo = sessionStorage.getItem('cardBannerBackUrl') || ROUTER_URL.PROFILE;
		sessionStorage.removeItem('cardBannerBackUrl');

		history.replace(redirectTo);
	}, [history]);

	return <CardBanner onClick={handleClickCardBanner} isActionsDisabled={isWeb} onSkip={handleClickSkip} />;
};
